import { GraphQLClient } from 'graphql-request'

import { QueryDescriptor } from '../graphql/queryDescriptors';
import { getStorageToken } from '../utils/localStorage';

export const swrFetcher = async (
  descriptor: QueryDescriptor,
  variables: any,
) => {
  const token = getStorageToken();

  const client = new GraphQLClient(
    process.env.REACT_APP_GRAPHQL_API_URL!,
    { headers: { authorization: token ? `Bearer ${token}` : '' } }
  );

  if (typeof descriptor.query === "string") {
    return await client.request(
      descriptor.query,
      variables
    );
  } else {
    return await client.request(descriptor.query(variables));
  }
}